import { render, staticRenderFns } from "./history-record.vue?vue&type=template&id=65807bc9&scoped=true"
import script from "./history-record.vue?vue&type=script&lang=ts"
export * from "./history-record.vue?vue&type=script&lang=ts"
import style0 from "./history-record.vue?vue&type=style&index=0&id=65807bc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65807bc9",
  null
  
)

export default component.exports